import { render } from "./BranchesTable.vue?vue&type=template&id=64b62084"
import script from "./BranchesTable.vue?vue&type=script&lang=ts"
export * from "./BranchesTable.vue?vue&type=script&lang=ts"

import "./BranchesTable.vue?vue&type=style&index=0&id=64b62084&lang=scss"
script.render = render

export default script